import Entity from './entity';

export default class extends Entity {
  constructor(global, registerdClickHandlers) {
    super(global);
    this.registerdClickHandlers = registerdClickHandlers;
    
    document.addEventListener('click', (event) => {
      // Traverse everything in this clicks path
      try {
        const path = event.path || (event.composedPath ? event.composedPath() : []);
        if (path.length === 0) {
          path.push(event.target);
        }
        path.forEach((element) => {
          // .. and it's attributes ...
          if (undefined !== element.getAttributeNames) {
            if (element.classList.contains('eh_checkbox')) {
              // Don't let the checkbox screw us over, throw an Error to breakout of forEach
              throw new Error('EH_CHECKBOX');
            }
            element.getAttributeNames()
              .filter((attributeName) => attributeName.indexOf('data-') > -1)
              .forEach((attributeName) => {
                // ... check it contains our registered hook ...
                const hookName = attributeName.substr(5);
                if (this.registerdClickHandlers[hookName] !== undefined) {
                  // ... squash and execute!

                  event.preventDefault();

                  if ((('disabled' in element) && element.disabled) || element.classList.contains('button-disabled')) {
                    return;
                  }

                  const functionName = this.registerdClickHandlers[hookName];
                  const attributeValue = element.getAttribute(attributeName);
                  this[functionName](attributeValue, element);

                  // We need to throw an Error to break out of a forEach 
                  throw new Error('FOUND');
                }
              });
          }
        });
      } catch (e) {
        // Exceptions we ignore.
        if (['EH_CHECKBOX', 'FOUND'].indexOf(e.message) === -1) {
          throw e;
        }
      }
    });
  }
}